<template>
    <g>
        <path :style="{ fill: color }" d="M37,29.5c0,0,0-2.1-0.7-3.4c-0.7-1.3-2.3-0.4-2.7,0.3c-0.3,0.6-1.3,1.4-1.1,3.3c0,0.1,0,0.2,0,0.4
	c0.2,1.3,0.4,2.4,0.4,3.3c0.1,1.1-0.2,2.6-0.1,3.6c0.1,2.1,0.5,3.3,0.5,3.5c0.8,0.6,1.5,5.1,1.8,5.1c0.3-0.1,0.4-3.4,0.5-5.2
	c0.1-1.7,1.2-3.3,1.4-6.3C37,32.3,36.8,30.9,37,29.5L37,29.5z"/>
        <path :style="{ fill: color }" d="M72,29.5c0,0,0-2.1,0.7-3.4c0.7-1.3,2.3-0.4,2.7,0.3c0.3,0.6,1.3,1.4,1.1,3.3c0,0.1,0,0.2,0,0.4
	c-0.2,1.3-0.4,2.4-0.4,3.3c-0.1,1.1,0.2,2.6,0.1,3.6c-0.1,2.1-0.5,3.3-0.5,3.5c-0.8,0.6-1.5,5.1-1.8,5.1c-0.3-0.1-0.4-3.4-0.5-5.2
	c-0.1-1.7-1.2-3.3-1.4-6.3C72,32.3,72.2,30.9,72,29.5L72,29.5z"/>
    </g>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair1',
        mixins: [Hair],
    }
</script>
